import { createApp, App as IAapp } from 'vue';
// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n';
import App from './App.vue';
import router from './router';
import plugins from './plugins';
import store from './store/index';
import 'virtual:uno.css';
import 'virtual:svg-icons-register';
// 引入message组件样式
import 'element-plus/theme-chalk/src/message.scss';
import 'element-plus/theme-chalk/src/message-box.scss';
import { setupGlobCom } from './components';
import './responsive.ts';

const setup = async () => {
    const app = createApp(App);
    app.use(router);
    app.use(store);
    setupGlobCom(app);
    await setupI18n(app);
    app.use(plugins);
    app.mount('#app');
};
setup();
